<div class="item">
  <span class="thin">Material</span>
  <creative-status-badge [creativeStatus]="creativeStatus"></creative-status-badge>
</div>
